import stockApi from "@/api/stock";
import warehouseApi from "@/api/warehouse";
const stock = {
  state: {
    warehouseList: [],
    carrierList: [],
  },
  getters: {
    warehouseList(state) {
      return state.warehouseList.map((warehouse) => {
        return {
          value: warehouse.warehouseId,
          label: warehouse.warehouseName,
        };
      });
    },
    carrierList(state) {
      return state.carrierList.map((carrier) => {
        return {
          value: carrier.code,
          label: carrier.name,
        };
      });
    },
  },
  mutations: {
    setWarehouseList(state, data) {
      state.warehouseList = data;
    },
    setCarrierList(state, data) {
      state.carrierList = data;
    },
  },
  actions: {
    stockList({ commit }, data) {
      return stockApi.getStockList(data);
    },
    downloadStockList({ commit }, data) {
      return stockApi.submitDownloadBatchStockTask(data);
    },
    previewBatchImportSkuStockAdjust({ commit }, data) {
      return stockApi.previewBatchImportSkuStockAdjust(data);
    },
    batchAdjustStock({ commit }, data) {
      return stockApi.batchAdjustStock(data);
    },
    adjustStock({ commit }, data) {
      return stockApi.adjustStock(data);
    },
    purchaseList({ commit }, data) {
      return stockApi.getPurchase(data);
    },
    comfirmPurchaseOrder({ commit }, data) {
      return stockApi.confirmPurchaseOrder(data);
    },
    getStockinList({ commit }, data) {
      return stockApi.getStockinList(data);
    },
    stockinDetail({ commit }, data) {
      return stockApi.getStockinDetail(data);
    },
    saveStockinInfo({ commit }, data) {
      return stockApi.saveCallbackInfo(data);
    },
    queryWarehouseList({ commit }, data) {
      warehouseApi.getWarehouseList().then((res) => {
        commit("setWarehouseList", res.result);
      });
    },
    queryCarrierList({ commit }, data) {
      stockApi.queryCarrier().then((res) => {
        commit("setCarrierList", res.result);
      });
    },
    merchantStockList({ commit }, data) {
      return stockApi.queryMerchantStock(data);
    },
    downloadMerchantStockList({ commit }, data) {
      return stockApi.downloadMerchantStock(data);
    },
  },
};

export default stock;
